var _SocketLoginCommand_socket;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export class SocketLoginCommand {
    constructor(socket) {
        _SocketLoginCommand_socket.set(this, void 0);
        __classPrivateFieldSet(this, _SocketLoginCommand_socket, socket, "f");
    }
    execute(privateKey) {
        if (!privateKey) {
            console.log('invalid value');
            return;
        }
        __classPrivateFieldGet(this, _SocketLoginCommand_socket, "f").send({
            commandType: 'user-login',
            resource: {
                channel: 'chat',
                privateKey: privateKey,
            },
        });
    }
}
_SocketLoginCommand_socket = new WeakMap();
